import { Dispatch, SetStateAction } from 'react';
import { PaymentMethod } from 'react-easyrocket';
import { useCryptochill } from '../../hooks/useCryptochill';
import classNames from 'classnames';
import { CryptoIcon } from 'src/components/svg/CryptoIcon';
import { MethodsIcon } from 'src/components/svg/MethodsIcon';

interface TabsDepositProps {
  setPaymentMethod: Dispatch<SetStateAction<PaymentMethod | undefined>>;
  currentMethods: 'methods' | 'crypto';
  setCurrentMethods: Dispatch<SetStateAction<'methods' | 'crypto'>>;
}

export const TabsDeposit = ({
  setPaymentMethod,
  setCurrentMethods,
  currentMethods
}: TabsDepositProps) => {
  const { cryptoMethods, handleCryptoMethodSelect } = useCryptochill();

  const handleBasicMethods = () => {
    setCurrentMethods('methods');
    setPaymentMethod(undefined);
  };

  const handleCryptoMethods = () => {
    setCurrentMethods('crypto');
    handleCryptoMethodSelect(cryptoMethods[0]);
  };

  const TABS = [
    { label: 'Methods', key: 'methods', onClick: handleBasicMethods },
    { label: 'Crypto', key: 'crypto', onClick: handleCryptoMethods }
  ];
  return (
    <div className="flex bg-as_mobile_bg rounded-[20px] mb-4">
      {TABS.map((tab) => {
        return (
          <div
            onClick={tab.onClick}
            key={tab.key}
            className={classNames(
              'px-5 py-3 font-bold flex flex-row justify-center text-center text-sm whitespace-nowrap flex-1 cursor-pointer rounded-[20px]',
              {
                'active-tab text-bg_main': currentMethods === tab.key,
                'text-gc_text': currentMethods !== tab.key
              }
            )}>
            {tab.key === 'crypto' ? (
              <CryptoIcon
                className="self-center"
                fill={currentMethods === tab.key ? 'var(--bg_main)' : 'var(--gc_text)'}
              />
            ) : (
              <MethodsIcon
                className="self-center mr-1"
                fill={currentMethods === tab.key ? 'var(--bg_main)' : 'var(--gc_text)'}
              />
            )}{' '}
            <p>{tab.label}</p>
          </div>
        );
      })}
    </div>
  );
};
